<template>
<div>
    <h1>{{title}}</h1>

    <div ref="myChartsContainer"></div>
</div>
</template>

<script>
//window.Highcharts = require("highcharts"); // Since 4.2.0
import Highcharts from "highcharts";

export default {
  name: "ChartsContainer",

  props: {
    title: String,
    xLabel: String,
    yLabel: String,
    chartSeries: Object
  },
  data() {
    return {
      chart: {},
      chartconfig: {
        chart: { zoomType: "x" },
        title: { text: this.title },
        xAxis: {
          type: "datetime",
          labels: {
            formatter: function() {
              return Highcharts.dateFormat("%m.%Y", this.value);
            }
          } /*,
                    tickInterval: 1,
                    minPadding: 0,
                    maxPadding: 0,
                    startOnTick: true,
                    endOnTick: true
                    */
        },
        yAxis: {
          title: { text: this.yLabel },
          plotLines: [],
          //min: 0
          //max: 80000 /* grenzwert 80'000 */,
          //tickInterval: 20000
          labels: {
            formatter: function() {
              return parseFloat(this.value).toLocaleString("de-CH")
            }
          }
        },
        tooltip: {
          headerFormat: "",
          pointFormat: "{point.x:%d.%m.%Y}: {point.y:.2f}",
          formatter: function() {
              return  Highcharts.dateFormat("%d.%m.%Y", this.x) +'/'+ parseFloat(this.y).toLocaleString("de-CH")
            }
        },
        plotOptions: {
          area: {
            fillColor: {
              linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
              stops: [
                [0, Highcharts.getOptions().colors[0]],
                [
                  1,
                  Highcharts.Color(Highcharts.getOptions().colors[0])
                    .setOpacity(0)
                    .get("rgba")
                ]
              ]
            },
            marker: { radius: 2 },
            lineWidth: 1,
            states: {
              hover: {
                lineWidth: 1
              }
            },
            threshold: null,
            negativeColor: null
          }
        },
        series: [
          {
            name: this.title,
            data: [
              /*
              [Date.UTC(1971, 6, 4), 0]
              */
            ]
          }
        ]
      }
    };
  },
  computed: {},
  methods: {
    setChartSeries(series) {
      this.chartconfig.series = series;
      this.reloadChart();
    },
    setGrenzwert(grenzwertX) {
      if (grenzwertX === undefined) {
        this.chartconfig.yAxis.plotLines = [];
      } else {
        this.chartconfig.yAxis.plotLines = [
          {
            value: grenzwertX, //chartconfig.yAxis.plotLines[1].value
            color: "red",
            dashStyle: "shortdash",
            width: 2,
            label: {
              text:
                this.$t("Grenzwert") +
                " " +
                parseFloat(grenzwertX).toLocaleString("de-CH")
            },
            zIndex:2 // grid ist per default = 1 gridZIndex
          }
        ];
      }

      this.reloadChart();
    },
    reloadChart: function() {
      this.chart = Highcharts.chart(
        this.$refs.myChartsContainer,
        this.chartconfig
      );
    }
  }
};
</script>